import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpWrapperService } from '.././http-wrapper.service';
import { IHttpRequestOptions } from '../../interfaces/http-request-option.interface';
import { PagedResult } from '../../interfaces/IPagingResponseModel.interface';
import { IPagingRequestModel } from '../../interfaces/IPagingRequestModel.interface';
import { HttpHeaders } from '@angular/common/http';
import { IDictionary } from '../../interfaces/common.interfaces';
import { FormSubmitDto, IFormListingDto, IFormMaster, IPaymentIntentRequest, IPaymentIntentResponse } from '../../interfaces/app-form.interface';


@Injectable({
  providedIn: 'root',
})
export class AppFormService {
  private readonly jsonHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
  constructor(private readonly httpWrapperService: HttpWrapperService) {}

  getMasterForms(
    communityId: number,
    request: IPagingRequestModel,
  ): Observable<PagedResult<IFormMaster>> {
    let url = `formmaster/list/${communityId}`;

    const options: IHttpRequestOptions = {
      url: url,
      headers: this.jsonHeaders,
      body: request
    };
    return this.httpWrapperService
      .postFromApiGateWay(options)
      .pipe(map((response: PagedResult<IFormMaster>) => response));
  }

  getFormById(formId: number): Observable<IFormMaster> {
    let url = `formmaster/${formId}`;

    const options: IHttpRequestOptions = {
      url: url,
      headers: this.jsonHeaders
    };
    return this.httpWrapperService
      .getFromApiGateWay(options)
      .pipe(map((response: IFormMaster) => response));
  }

  getDataForFilters(
    communityId: number,
  ): Observable<IDictionary<string, string[]>> {
    let url = `formmaster/filters/${communityId}`;

    const options: IHttpRequestOptions = {
      url: url,
      headers: this.jsonHeaders
    };
    return this.httpWrapperService
      .getFromApiGateWay(options)
      .pipe(map((response: IDictionary<string, string[]>) => response));
  }

  updateFormData(formData: IFormMaster): Observable<any> {
    const url = `formmaster`;
    const options: IHttpRequestOptions = {
      url: url,
      headers: this.jsonHeaders,
      body: formData,
    };

    return this.httpWrapperService
      .putFromApiGateWay(options)
      .pipe(map((response: any) => response));
  }
  
  saveFormData(formData: IFormMaster, id:number): Observable<any> {
    const url = `formmaster/${id}`;
    const options: IHttpRequestOptions = {
      url: url,
      headers: this.jsonHeaders,
      body: formData,
    };

    return this.httpWrapperService
      .postFromApiGateWay(options)
      .pipe(map((response: any) => response));
  }

  submitForm(formData: FormSubmitDto): Observable<any> {
    const url = `formsubmit`;
    const options: IHttpRequestOptions = {
      url: url,
      headers: this.jsonHeaders,
      body: formData,
    };

    return this.httpWrapperService
      .postFromApiGateWay(options)
      .pipe(map((response: any) => response));
  }

  getCustomFormsData(communityId: number): Observable<IFormMaster[]> {
    const url = `formmaster/customlist/${communityId}`;
    const options: IHttpRequestOptions = {
      url: url,
      headers: this.jsonHeaders,
    };
    return this.httpWrapperService
      .getFromApiGateWay(options)
      .pipe(map((response: IFormMaster[]) => response));
  }
  getPaymentIntent(paymentIntent: IPaymentIntentRequest): Observable<IPaymentIntentResponse> {
    const url = `StripePayment/create-payment-intent`;
    const options: IHttpRequestOptions = {
      url: url,
      headers: this.jsonHeaders,
      body: paymentIntent,
    };

    return this.httpWrapperService
      .postFromApiGateWay(options)
      .pipe(map((response: IPaymentIntentResponse) => response));
  }
  
getFormListing(communityId: number): Observable<IFormListingDto[]> {
  const url = `formmaster/form-listing/${communityId}`;
  const options: IHttpRequestOptions = {
    url: url,
    headers: this.jsonHeaders
  };

  return this.httpWrapperService
    .getFromApiGateWay(options)
    .pipe(
      map((response: IFormListingDto[]) => response)
    );
}
}